import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { ScriptService } from '../../service/script.service';
import { AccountService } from '../../service/account.service';

@Component({
  selector: 'app-script-sunset-banner',
  imports: [MatCardModule, MatIconModule, MatButtonModule, MatFormFieldModule, MatSelectModule, MatOptionModule, MatListModule],
  templateUrl: './script-sunset-banner.component.html',
  styleUrl: './script-sunset-banner.component.less'
})
export class ScriptSunsetBannerComponent {

  accountService = inject(AccountService);

  get isCreationAllowed() { return ScriptService.isCreationAllowed() || this.accountService.account.value?.staff === true; }
  get isEditAllowed() { return ScriptService.isEditAllowed() || this.accountService.account.value?.staff === true; }

  scriptService: ScriptService = inject(ScriptService);


  constructor() { }

  ngOnInit(): void {
  }

}
